import { Accordion, Box, Button, Chip } from '@mui/material'
import { styled } from '@mui/material/styles'

export const PageWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  height: '100vh',
  overflow: 'hidden',
}))

export const Wrapper = styled('div')({
  display: 'flex',
  padding: '0px 0px 10px',
  alignItems: 'center',
  flexDirection: 'column',
  overflowY: 'scroll',
  height: '90%',
})

export const PageContainer = styled('div')({
  width: '80%',
  height: '100%',
  padding: '20px 0px',
  '@media (max-width: 1024px)': {
    width: '90%',
  },
})

export const MainWrapper = styled('div')({
  height: '83vh',
  width: '100%',
})

export const PageHeader = styled('div')(({ theme }) => ({
  background: theme.palette.background.paper, //theme.WHITE
  padding: 15,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const FilterButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper, //theme.WHITE
  color: theme.palette.primary.main,
  fontWeight: '500',
  fontSize: '14px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.background.paper, //theme.WHITE
    color: theme.palette.primary.main,
  },
  '&:focus': {
    backgroundColor: theme.palette.primary.light, //theme.PRIMARY_80
    color: theme.palette.primary.main,
  },
  '&.active': {
    backgroundColor: theme.palette.primary.light, //theme.PRIMARY_80
    color: theme.palette.primary.main,
  },
}))

export const BtnWrapper = styled('div')({
  display: 'flex',
  gap: 10,
})

export const TitleShowDown = styled(Accordion)({
  background: 'inherit',
  boxShadow: 'none',
  ':before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-root': {
    padding: 0,
    '& .Mui-expanded': {
      margin: 0,
    },
  },
  '& .MuiAccordionDetails-root': {
    padding: 0,
  },
})

export const AccordionTitle = styled('span')({
  fontWeight: 500,
  fontSize: '24px',
})

export const SubItemCard = styled('div')({
  display: 'flex',
  gap: 5,
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  '&.columns': {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  '@media (max-width: 960px)': {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
})

export const TaskTitleWrapper = styled('div')({
  whiteSpace: 'normal',
  flex: 1,
  '&.columns': {
    maxWidth: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

export const LoadingWrapper = styled('div')({
  display: 'flex',
  marginTop: 10,
  width: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
})

export const LoadingTask = styled('div')({
  display: 'flex',
  padding: '4px',
})

export const TitleShowDownItem = styled(TitleShowDown)(({ theme }) => ({
  padding: '8px',

  '& .MuiAccordionSummary-root': {
    background: theme.palette.background.paper, //theme.WHITE
    borderRadius: theme.shape.customBorderRadius.main,
    '& .MuiAccordionSummary-content': {
      display: 'block',
    },
    '&.Mui-expanded': {
      padding: '8px',
      background: theme.palette.grey[100], //'#F5F5F5',
      border: `1px solid ${theme.palette.divider}`, //#B0B7C3
      minHeight: '30px',
    },
    '&.columns': {
      backgroundColor: theme.palette.grey[50],
    },
  },
}))

export const TitleShowDownSubItem = styled('div')(({ theme }) => ({
  background: theme.palette.grey[100], //'#F5F5F5'
  border: `1px solid ${theme.palette.divider}`, //#B0B7C3
  margin: '10px 0px',
  padding: '3px 10px 3px 20px',
  borderRadius: theme.shape.customBorderRadius.main,
}))

export const TaskGroupWrapper = styled('div')({
  width: '100%',
})
export const EmptyWrapper = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const EmptyContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontWeight: 500,
  fontSize: 20,
  gap: 15,
  color: theme.palette.text.secondary, //theme.TEXT_SECONDARY_02
}))

export const StyledChip = styled(Chip)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 400,
  fontSize: 13,
  textTransform: 'capitalize',
  '&.LOW': {
    background: theme.palette.background.default,
    color: theme.palette.primary.main,
  },
  '&.MEDIUM': {
    background: theme.palette.warning.light, //theme.WARNING_OUTLINED
    color: theme.palette.warning.main,
  },
  '&.HIGH': {
    background: theme.palette.error.light, //theme.ERROR_OUTLINED
    color: theme.palette.error.main,
  },
  '&.URGENT': {
    background: theme.palette.error.light, //theme.ERROR_OUTLINED
    color: theme.palette.error.main,
  },
}))

export const DateWrapper = styled('div')(({ theme }) => ({
  padding: '8px',
  borderRadius: theme.shape.customBorderRadius.main,
  display: 'flex',
  alignItems: 'center',
  background: 'rgba(35, 97, 146, 0.08)', //theme.palette.primary.light,
  color: theme.palette.primary.main,
  gap: 10,
  fontWeight: 500,
  fontSize: '14px',
}))

export const TaskNumber = styled(DateWrapper)({
  width: '41px',
  borderRadius: '15rem',
  justifyContent: 'center',
})

export const InfoWrapper = styled('div')({
  display: 'flex',
  gap: '10px',
  paddingRight: 16,
  alignItems: 'center',
  justifyContent: 'end',
  '&.p-0': {
    paddingRight: 0,
  },
  width: 'auto',
  flexWrap: 'wrap',
  '&.columns': {
    justifyContent: 'flex-start',
    paddingLeft: 24,
  },
  '@media (max-width: 960px)': {
    justifyContent: 'flex-start',
  },
})

export const EqualColWrapper = styled('div')({
  '&.center-child': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  '&.justify-center': {
    display: 'flex',
    justifyContent: 'center',
  },
})

export const FormControlLabelWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
})

export const AssignedToContainer = styled(Box)({
  display: 'block',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'pre',
  width: '100%',
})

export const TaskDescWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  // '&.columns': {
  //   alignItems: 'flex-start',
  // },
  // '@media (max-width: 960px)': {
  //   alignItems: 'flex-start',
  // },
})
